// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
function getDevicePixelRatio(url) {
  var isGif = url.endsWith(".gif");
  if (isGif) {
    return 1;
  } else {
    return Belt_Option.getWithDefault(Belt_Option.map(window.devicePixelRatio, function (dpr) {
      var dpr$1 = Math.round(dpr) | 0;
      if (dpr$1 < 2) {
        return dpr$1;
      } else {
        return 2;
      }
    }), 1);
  }
}
function encodeImageUrl(input) {
  var tmp;
  if (input.includes("whisperinghomes")) {
    var url = new URL(input);
    url.searchParams.append("t", "28348993");
    tmp = url.href;
  } else {
    tmp = input;
  }
  return encodeURIComponent(tmp);
}
function makeUrl(url, w, h, crop, unit) {
  var w$1 = Belt_Option.mapWithDefault(w, "", function (w) {
    return ",w_" + String(w);
  });
  var h$1 = Belt_Option.mapWithDefault(h, "", function (h) {
    return ",h_" + String(h);
  });
  var dpr = getDevicePixelRatio(url);
  var dpr$1;
  switch (dpr) {
    case 1:
      dpr$1 = ",dpr_1";
      break;
    case 2:
      dpr$1 = ",dpr_2";
      break;
    case 3:
      dpr$1 = ",dpr_3";
      break;
    default:
      dpr$1 = "";
  }
  var c;
  switch (crop) {
    case /* Limit */0:
      c = ",c_limit";
      break;
    case /* Fill */1:
      c = ",c_fill";
      break;
    case /* Fit */2:
      c = ",c_fit";
      break;
  }
  var f = url.endsWith(".svg") ? "f_svg" : "f_auto";
  return "https://res.cloudinary.com/makerinc/image/fetch/" + f + ",q_auto,fl_preserve_transparency" + c + dpr$1 + w$1 + h$1 + "/" + encodeImageUrl(url);
}
function makeCoverUrl(url, w, h, param) {
  var w$1 = Belt_Option.mapWithDefault(w, "0", function (w) {
    return String(w);
  });
  var h$1 = Belt_Option.mapWithDefault(h, "0", function (h) {
    return String(h);
  });
  var dpr = getDevicePixelRatio(url);
  var dpr$1;
  switch (dpr) {
    case 1:
      dpr$1 = "dpr_1";
      break;
    case 2:
      dpr$1 = "dpr_2";
      break;
    case 3:
      dpr$1 = "dpr_3";
      break;
    default:
      dpr$1 = "";
  }
  var f = url.endsWith(".svg") ? "f_svg" : "f_auto";
  var expression = ",c_fit,$bw_" + w$1 + ",$bh_" + h$1 + ",$dw_$bw_div_iw,$dh_$bh_div_ih/if_$dh_lt_$dw/w_$bw/if_else/h_$bh/if_end/";
  return "https://res.cloudinary.com/makerinc/image/fetch/" + f + ",q_auto,fl_preserve_transparency" + expression + dpr$1 + "/" + encodeImageUrl(url);
}
export { getDevicePixelRatio, encodeImageUrl, makeUrl, makeCoverUrl };
/* No side effect */